import EntityInputField from 'vue-forms/components/EntityInputField';
import TagService from 'app/services/TagService';
import http from 'core/http/HttpService';
import env from 'environment';

export default {
  mixins: [ EntityInputField ],

  props: {
    service: {
      default: () => TagService
    },

    idField: {
      default: 'id'
    },

    context: {
      type: String,
      default: 'default'
    },

    contextId: {
      default: undefined
    }
  },

  methods: {
    loadOptionsForContext(context) {
      this.internalError = null;
      this.loading = true;

      const success = ({ statusCode, data }) => {
        console.log('data', data);
        this.options = data;
        this.loading = false;
      };

      const error = ({ statusCode, data }) => {
        console.log('error', statusCode, data);
        this.internalError = 'Cannot load options';
        this.loading = false;
      }

      http.get({
        url: env.baseUrl + '/' + this.context + '/' + this.contextId + '/allowed-tags'
      }).then(success, error);
    },

    loadOptions() {
      if (this.context === 'default') {
        this.loadOptionsDefault();
      } else {
        this.loadOptionsForContext(this.context);
      }
    },

    customLabel(item) {
      return item.label;
    },

    customTags(result) {
      if (!result.workgroup) {
        return [];
      }

      const text = result.workgroup.name;
      let variant, help;
      if (result.workgroup.type === 'ADMINISTRATOR') {
        variant = 'primary';
        help = `${result.label} è un tag del gruppo ${result.workgroup.name}, di cui sei amministratore`;
      } else if (result.workgroup.type === 'ORDINARY') {
        variant = 'success';
        help = `${result.label} è un tag del gruppo ${result.workgroup.name}, di cui sei utente ordinario`;
      } else if (result.workgroup.type === 'GUEST') {
        variant = 'warning';
        help = `${result.label} è un tag del gruppo ${result.workgroup.name}, di cui sei ospite`;
      }
      return [{ text, variant, help }];
    }
  }
};
